import React, { useContext, useEffect } from 'react';
import { getScrollWidth } from "../../../lib/dom/getScrollWidth";
import { Sticky } from "../../Sticky";
import { ThemeContext } from "../../../lib/theming/ThemeContext";
import { ZIndex } from "../../../internal/ZIndex";
import { CommonWrapper } from "../../../internal/CommonWrapper";
import { cx } from "../../../lib/theming/Emotion";
import { styles } from "../Modal.styles";
import { ModalContext } from "../ModalContext";
/**
 * Футер модального окна.
 *
 * @visibleName Modal.Footer
 */

function ModalFooter(props) {
  var _props$sticky = props.sticky,
      sticky = _props$sticky === void 0 ? true : _props$sticky,
      panel = props.panel,
      children = props.children;
  var theme = useContext(ThemeContext);
  var modal = useContext(ModalContext);
  useEffect(function () {
    modal.setHasFooter == null ? void 0 : modal.setHasFooter();
    modal.setHasPanel == null ? void 0 : modal.setHasPanel(panel);
    return function () {
      modal.setHasFooter == null ? void 0 : modal.setHasFooter(false);
      modal.setHasPanel == null ? void 0 : modal.setHasPanel(false);
    };
  }, [panel]);

  var renderContent = function renderContent(fixed) {
    var _cx;

    if (fixed === void 0) {
      fixed = false;
    }

    return /*#__PURE__*/React.createElement("div", {
      className: cx((_cx = {}, _cx[styles.footer(theme)] = true, _cx[styles.fixedFooter(theme)] = fixed, _cx[styles.panel(theme)] = Boolean(panel), _cx))
    }, children);
  };

  return /*#__PURE__*/React.createElement(CommonWrapper, props, /*#__PURE__*/React.createElement(ZIndex, {
    priority: 'ModalFooter',
    className: styles.footerWrapper()
  }, sticky ? /*#__PURE__*/React.createElement(Sticky, {
    side: "bottom",
    offset: modal.horizontalScroll ? getScrollWidth() : 0
  }, renderContent) : renderContent()));
}

ModalFooter.__KONTUR_REACT_UI__ = 'ModalFooter';
ModalFooter.__MODAL_FOOTER__ = true;
export { ModalFooter };